import state from './moduleAppUserState.js';
import mutations from './moduleAppUserMutations.js';
import actions from './moduleAppUserActions.js';
import getters from './moduleAppUserGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
